import React from "react";
import { Placeholder, Table } from "react-bootstrap";

function SkeletonTable({ columns = 5, rows = 8 }) {
  // Vary widths to look realistic
  const widthPattern = [75, 50, 90, 60, 45, 80, 55, 70];

  return (
    <Placeholder as="div" animation="glow">
      <Table bordered hover className="align-middle mb-0">
        <thead>
          <tr>
            {Array(columns)
              .fill(null)
              .map((_, i) => (
                <th key={i} className="py-2">
                  <Placeholder xs={4} size="sm" />
                </th>
              ))}
          </tr>
        </thead>
        <tbody>
          {Array(rows)
            .fill(null)
            .map((_, rowIdx) => (
              <tr key={rowIdx}>
                {Array(columns)
                  .fill(null)
                  .map((_, colIdx) => (
                    <td key={colIdx} className="py-2">
                      <Placeholder
                        xs={widthPattern[(rowIdx + colIdx) % widthPattern.length] > 60 ? 8 : 5}
                        size="sm"
                      />
                    </td>
                  ))}
              </tr>
            ))}
        </tbody>
      </Table>
    </Placeholder>
  );
}

export default SkeletonTable;
